import * as React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { ICompanyIntraModule } from "../../../models/intraModule/companyIntraModule";
import { ListExternalSystemLine } from "../../framework/List/ListExternalSystemLine";
import { ListHeaderLine } from "../../framework/List/ListLine";

export interface ICompanyEditIntraModulesProp {
    intraModules: ICompanyIntraModule[];
    onToggeIntraModuleInUse: (code: string, value: boolean) => void;
    onChangeIntraModuleExternalCode: (code: string, value: string) => void;
}

export class CompanyEditIntraModules extends React.Component<ICompanyEditIntraModulesProp, {}> {
    handleChangeIntraModuleExternalCode = (event) => {
        const target = event.target;
        const value: string = target.value;
        const code: string = target.name;
        if (!code) return;
        this.props.onChangeIntraModuleExternalCode(code, value);
    };

    render() {
        const props = this.props;
        const intraModules = props.intraModules;
        if (!intraModules || intraModules.length < 0) return null;
        return (
            <>
                <ListHeaderLine
                    columns={[
                        { size: 7, column: "name", content: Translations.Name },
                        { size: 5, column: "externalSystemCode", content: Translations.ExternalSystemCode }
                    ]}
                />
                {intraModules.map((intraModule) =>
                    <ListExternalSystemLine
                        key={intraModule.code}
                        code={intraModule.code}
                        name={intraModule.name}
                        checked={intraModule.inUse}
                        value={intraModule.externalCode}
                        rootUrl={appConfig.rootUrl}
                        usesExternalCode={intraModule.usesExternalCode}
                        onCheckChange={props.onToggeIntraModuleInUse}
                        onInputChange={this.handleChangeIntraModuleExternalCode}
                    />
                )}
            </>
        );
    }
}